// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

import i18n from './analysis-context-visibility-mode.properties';

const ANALYSIS_CONTEXT_VISIBILITY_MODE_TO_PERSISTENCE_KEY = {
  AUTO: 'auto',
  ALWAYS_VISIBLE: 'always-visible',
  ALWAYS_HIDDEN: 'always-hidden'
} as const;

/** @see net/disy/cadenza/workbook/model/AnalysisContextVisibilityMode.java */
export type AnalysisContextVisibilityMode = keyof typeof ANALYSIS_CONTEXT_VISIBILITY_MODE_TO_PERSISTENCE_KEY;

export const AnalysisContextVisibilityMode = {
  values: Object.keys(ANALYSIS_CONTEXT_VISIBILITY_MODE_TO_PERSISTENCE_KEY) as readonly AnalysisContextVisibilityMode[],
  toPersistenceKey: (value: AnalysisContextVisibilityMode) => ANALYSIS_CONTEXT_VISIBILITY_MODE_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = AnalysisContextVisibilityMode.values.find(key => ANALYSIS_CONTEXT_VISIBILITY_MODE_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No AnalysisContextVisibilityMode for key: ${persistenceKey}`); }
    return value;
  },
  i18n: (value: AnalysisContextVisibilityMode) => i18n(`<${value}>`),
} as const;

// </GENERATED-CODE>
